import React, {} from 'react'

import {  Typography, Box, Card, CardContent, CardActions, Button } from '@mui/material';
import { Skid } from '../AvailableSkids/skidsWithConfigProvider';
import { Link } from 'react-router-dom';
import { type SkidHeader,SkidHeaders } from '../../Pages/Landing';
import { determineDisplayName } from '../AvailableSkids/skidsWithConfigProvider';
import "./landing.css";
interface SkidCardProps{
    skid: Skid
    skidHeader?: SkidHeader
    skidStatus?:string
    Operator?:string
    Country?:string
    RigName?:string
    RigType?:string
}

function displaySkidStatus(status:string|undefined):string{
    if (!status){
        return "Unknown"
    }
    switch(status.toLowerCase()){
        case 'running':
            return "Operational"
        case 'idle':
            return "Idle"
        case 'disconnected':
            return"Standby"
        default:
            return "Offline"
    }
}
function statusToColor(status:string|undefined):string{
     if (!status){
        return "#bbb"
    }
     switch(status.toLowerCase()){
        case 'running':
            return "#39FF14"
        case 'idle':
            return "#FFFF33"
        case 'disconnected':
            return"#FF3131"
        default:
            return "#bbb"
    }
}
function statusToClass(status:string|undefined):string{
     if (!status){
        return "dot-disconnected"
    }
     switch(status.toLowerCase()){
        case 'running':
            return "dot-active"
        case 'idle':
            return "dot-idle"
        case 'disconnected':
            return"dot-standby"
        default:
            return "dot-disconnected"
    }
}
export function SkidCard(props:SkidCardProps) {
    const {skid, skidHeader, skidStatus} = props
    var skidStatusLocal = skidStatus
    if (!skidStatus){
        skidStatusLocal = "Unknown"
    }
    var displayName = skid.displayName
    if (displayName==null) {
        displayName = skid.name
    }
    //console.log('Skid:',skid.name,'header in card:', skidHeader)
    return (
        <div>
            <Card variant="outlined" sx={{ minWidth: 330, margin: 2, maxWidth:350, minHeight: 225, backgroundColor: "#0A1929", display: 'flex', flexDirection: 'column', justifyContent: 'space-between'     }}>
                <CardContent>
                    <div className='titleBox' style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
                        
                        <h5 style={{color: 'white', justifySelf:'center'}}>{displayName}</h5>
                        <span className={statusToClass(skidStatus)} style={{backgroundColor:statusToColor(skidStatus)}}></span>
                    </div>
                    
                    {skid && 
                    <Box sx={{mt:1, textAlign:'left'}}>
                        <Typography variant="body2" color="white" sx={{color:'white'}}>
                            Unit: {skid.unit}
                        </Typography>
                        <Typography variant="body2" color="white" sx={{color:'white'}}>
                            Operator: {skid.operator}
                        </Typography>
                        <Typography variant="body2" color="white" sx={{color:'white'}}>
                            Country: {skid.country}
                        </Typography>
                        <Typography variant="body2" color="white" sx={{color:'white'}}>
                            Rig Name: {skid.rigName}
                        </Typography>
                        <Typography variant="body2" color="white" sx={{color:'white'}}>
                            Rig Type: {skid.rigType}
                        </Typography>
                        <Typography variant="body2" color="white" sx={{color:'white'}}>
                            interface: {skid.interface}
                        </Typography>
                        
                    </Box>
                }
                {skidStatusLocal &&
                    <Box sx={{mt:1, textAlign:'left'}}>
                        <Typography variant="body1" color="white" sx={{color:'white'}}>
                            Status: {displaySkidStatus(skidStatusLocal)}
                        </Typography>
                    </Box>
                }
                </CardContent>
                <CardActions>
                    <Button variant="contained" color="primary" component={Link} state={{targetSkid:determineDisplayName(skid)}}to="/Live">Real-Time</Button>
                    <Button variant="contained" color="primary" component={Link} state={{targetSkid:determineDisplayName(skid)}}to="/Historic"> Historic </Button>
                    <Button variant="contained" color="primary" component={Link} state={{targetSkid:determineDisplayName(skid)}}to="/Rheoport"> Rheoport </Button>
                </CardActions>
                
            </Card>
        </div>
    )
}